import React, { useEffect, useRef, useState } from "react";
import {
  Row,
  Col,
  Form,
  Input,
  DatePicker,
  Select,
  message,
  Checkbox,
  Switch,
  Upload,
  Space,
  TimePicker,
  Button,
} from "antd";
import styled from "@emotion/styled";
import moment from "moment";
import {
  NON_EMPTY_REGEX,
  EMAIL_REGEX,
  countryList,
  Greetings,
  AwardList,
} from "common/Constants";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import { isEmpty } from "lodash";
import { CALL_API } from "common/API";

function generateUniqueId() {
  const usedIds = [];
  let uniqueId = "";
  while (uniqueId.length !== 6) {
    const randomNumber = Math.floor(Math.random() * 900000) + 100000;
    if (!usedIds.includes(randomNumber.toString())) {
      usedIds.push(randomNumber.toString());
      uniqueId += randomNumber.toString();
    }
  }
  return uniqueId;
}

const StyledButton = styled(Button)`
  background-color: #2d53da !important;
  border-radius: 5px;
  color: #fff !important;
  width: 100px;

  &:hover {
    color: #fff !important;
  }

  &:focus {
    color: #fff !important;
  }
`;

const StyleRow = styled(Row)`
  padding: 10px;
  box-shadow: 0px 3px 6px #00000015;
  .ant-form-item-label {
    text-align: left;
  }
  .ant-picker {
    width: 100% !important;
  }
  .ant-upload.ant-upload-select {
    width: 100% !important;
    color: #397ff4 !important;
    .ant-btn > span {
      display: inline-block;
      color: #397ff4;
    }
    button,
    html [type="button"],
    [type="reset"],
    [type="submit"] {
      background: #f2f2f2;
    }
    .ant-upload-list-picture .ant-upload-list-item,
    .ant-upload-list-picture-card .ant-upload-list-item {
      height: 40px;
    }
    .ant-upload-list-text .ant-upload-list-item-name,
    .ant-upload-list-picture .ant-upload-list-item-name {
      color: #397ff4;
    }
  }
`;

function EducationInfo({
  setStep,
  goBack,
  setFormValues,
  formValues,
  form,
  clientId,
}) {
  const { Option } = Select;
  const containerRef = useRef(null);
  const onFinish = (values) => {
    const currentFormValues = form.getFieldValue();
    setFormValues((prevValues) => ({
      ...prevValues,
      ...currentFormValues,
    }));
    setStep(2);
    console.log("Received values:", values);
    // Handle API calls or state updates here
  };

  const beforeUpload = (file) => {
    const isLt5M = file.size / 1024 / 1024 < 5;
    if (!isLt5M) {
      message.error("File must be smaller than 5MB!");
      return Upload.LIST_IGNORE; // ✅ prevents file from being added to list
    }
    return true;
  };

  const uploadFile = async (value) => {
    const { file } = value;
    try {
      if (!isEmpty(file)) {
        const { user_id } = formValues;
        await CALL_API(`upload-userdocuments/${clientId}`, "post", {
          userId: user_id?.toLowerCase(),
          name: file.name,
          type: file.type,
          uniqueId: file.response.uniqueId,
          content: file.response.base64Data,
        });
      }
    } catch (error) {
      console.error("[handlesubmit] error --->", error);
    }
  };

  useEffect(() => {
    if (!isEmpty(formValues)) {
      form.setFieldsValue(formValues);
    }
  }, [formValues]);
  return (
    <div>
      <Form
        form={form}
        name="dynamic_form_nest_item"
        onFinish={() => onFinish(4)}
        autoComplete="off"
        initialValues={{
          educationdetails: [
            {
              institutename: "",
              fromdate: "",
              todate: "",
              exambody: "",
              awarded: "",
              attachment: [],
            },
          ],
          practicaltrainings: [
            {
              organisationname: "",
              fromdate: "",
              todate: "",
              positionheld: "",
              tasksperformed: "",
            },
          ],
          professionalcertifications: [
            {
              certificationtype: "",
              fromdate: "",
              todate: "",
              remarks: "",
              attachment: [],
            },
          ],
        }}
        labelCol={{ xs: 24, sm: 24, md: 24 }}
        style={{ textAlign: "left" }}
      >
        <b>Education Details:</b>
        <Form.List name="educationdetails">
          {(fields, { add, remove }) => (
            <>
              {fields.map(({ key, name, ...restField }) => (
                <StyleRow gutter={16}>
                  <Col xs={24} sm={24} md={24}>
                    <Form.Item
                      {...restField}
                      label="Institute Name"
                      name={[name, "institutename"]}
                      // rules={[
                      //   {
                      //     required: true,
                      //     message: "Institute Name required",
                      //   },
                      // ]}
                    >
                      <Input
                        placeholder="Institute Name"
                        // onChange={onFinish}
                        onKeyDown={(e) => {
                          const allowedChars = /^[a-zA-Z\s]+$/;
                          if (!allowedChars.test(e.key)) {
                            e.preventDefault();
                          }
                        }}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={12} ref={containerRef}>
                    <Form.Item
                      {...restField}
                      label="From:"
                      name={[name, "fromdate"]}
                      // rules={[
                      //   { required: true, message: "Date required" },
                      // ]}
                    >
                      <DatePicker
                        className="w-100"
                        format="DD-MM-YYYY"
                        // onChange={() => {
                        //   onFinish();
                        // }}
                        placeholder="From"
                        getPopupContainer={() => containerRef.current}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={12} ref={containerRef}>
                    <Form.Item
                      {...restField}
                      label="To:"
                      name={[name, "todate"]}
                      // rules={[
                      //   { required: true, message: "Date required" },
                      // ]}
                    >
                      <DatePicker
                        className="w-100"
                        format="DD-MM-YYYY"
                        // onChange={() => {
                        //   onFinish();
                        // }}
                        placeholder="To"
                        getPopupContainer={() => containerRef.current}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={12}>
                    <Form.Item
                      {...restField}
                      label="Exam Body:"
                      name={[name, "exambody"]}
                      // rules={[
                      //   {
                      //     required: true,
                      //     message: "Exam Body required",
                      //   },
                      // ]}
                    >
                      <Input
                        placeholder="Exam Body"
                        // onChange={onFinish}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={12}>
                    <Form.Item
                      {...restField}
                      label="Awarded:"
                      name={[name, "awarded"]}
                      // rules={[
                      //   { required: true, message: "Awarded required" },
                      // ]}
                    >
                      <Select
                        placeholder="Select"
                        getPopupContainer={() => containerRef.current}
                      >
                        <Option value="Doctorate">Doctorate</Option>
                        <Option value="Master">Master</Option>
                        <Option value="Bachelor">Bachelor</Option>
                        <Option value="Diploma">Diploma</Option>
                        <Option value="Certificate">Certificate</Option>
                      </Select>
                    </Form.Item>
                    {/* <MinusCircleOutlined onClick={() => remove(name)} /> */}
                  </Col>
                  <Col xs={24} sm={24} md={24}>
                    <Form.Item
                      {...restField}
                      label="Attachment"
                      name={[name, "attachment"]}
                      valuePropName="fileList"
                      getValueFromEvent={(e) => {
                        if (Array.isArray(e)) {
                          return e;
                        }
                        return e && e.fileList;
                      }}
                    >
                      <Upload
                        beforeUpload={beforeUpload}
                        customRequest={({ file, onSuccess }) => {
                          const reader = new FileReader();
                          reader.readAsDataURL(file);

                          reader.onload = () => {
                            const base64Data = reader.result.split(",")[1];
                            const uniqueId = generateUniqueId();
                            onSuccess({ file, base64Data, uniqueId });
                          };

                          reader.onerror = (error) => {
                            console.error("File read error:", error);
                          };
                        }}
                        name="logo"
                        // action="/upload.do"
                        onChange={(value) => {
                          //  onFinish();
                          uploadFile(value);
                        }}
                        // onRemove={(file) => {
                        //   handleFileRemove(file);
                        // }}
                        listType="picture"
                        style={{ width: "100%" }}
                      >
                        <div style={{ width: "100%" }}>
                          <Button className="w-100 text-start" size="large">
                            Upload File
                          </Button>
                        </div>
                      </Upload>
                    </Form.Item>
                  </Col>
                </StyleRow>
              ))}
              <Form.Item>
                <u
                  className="bg-transparent border-0 text-start"
                  type="dashed"
                  onClick={() => add()}
                  block
                >
                  +Add Another
                </u>
              </Form.Item>
            </>
          )}
        </Form.List>
        <b>Practical Trainings:</b>
        <Form.List name="practicaltrainings">
          {(fields, { add, remove }) => (
            <>
              {fields.map(({ key, name, ...restField }) => (
                <StyleRow gutter={16} className="mt-2">
                  <Col xs={24} sm={24} md={24}>
                    <Form.Item
                      {...restField}
                      label="Organisation Name"
                      name={[name, "organisationname"]}
                      // rules={[
                      //   {
                      //     required: true,
                      //     message: "Organisation Name required",
                      //   },
                      // ]}
                    >
                      <Input
                        placeholder="Organisation Name"
                        onKeyDown={(e) => {
                          const allowedChars = /^[a-zA-Z\s]+$/;
                          if (!allowedChars.test(e.key)) {
                            e.preventDefault();
                          }
                        }}
                        // onChange={() => {
                        //   // onFinish();
                        // }}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={12} ref={containerRef}>
                    <Form.Item
                      {...restField}
                      label="From:"
                      name={[name, "fromdate"]}
                      // rules={[
                      //   { required: true, message: "Date required" },
                      // ]}
                    >
                      <DatePicker
                        className="w-100"
                        format="DD-MM-YYYY"
                        // onChange={() => {
                        //   // onFinish();
                        // }}
                        placeholder="From"
                        getPopupContainer={() => containerRef.current}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={12} ref={containerRef}>
                    <Form.Item
                      {...restField}
                      label="To:"
                      name={[name, "todate"]}
                      // rules={[
                      //   { required: true, message: "Date required" },
                      // ]}
                    >
                      <DatePicker
                        className="w-100"
                        format="DD-MM-YYYY"
                        // onChange={() => {
                        //   // onFinish();
                        // }}
                        placeholder="To"
                        getPopupContainer={() => containerRef.current}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={24}>
                    <Form.Item
                      {...restField}
                      label="Position Held"
                      name={[name, "positionheld"]}
                      // rules={[
                      //   {
                      //     required: false,
                      //     pattern:VALIDATE_CHARACTER,
                      //     message: "Invalid Position",
                      //   },
                      // ]}
                    >
                      <Input
                        placeholder="Position Held"
                        onKeyDown={(e) => {
                          const allowedChars = /^[a-zA-Z\s]+$/;
                          if (!allowedChars.test(e.key)) {
                            e.preventDefault();
                          }
                        }}
                        // onChange={() => {
                        //   // onFinish();
                        // }}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={24}>
                    <Form.Item
                      {...restField}
                      label="Nature of work & Tasks performed or completed"
                      name={[name, "tasksperformed"]}
                      // rules={[
                      //   {
                      //     required: true,
                      //     message:
                      //       "Nature of work & Tasks performed or completed required",
                      //   },
                      // ]}
                    >
                      <Input.TextArea
                        placeholder="Nature of work & Tasks performed or completed"
                        // onChange={() => {
                        //   // onFinish();
                        // }}
                      />
                    </Form.Item>
                    {/* <MinusCircleOutlined onClick={() => remove(name)} /> */}
                  </Col>
                </StyleRow>
              ))}
              <Form.Item>
                <u
                  className="bg-transparent border-0 text-start"
                  type="dashed"
                  onClick={() => add()}
                  block
                >
                  +Add Another
                </u>
              </Form.Item>
            </>
          )}
        </Form.List>
        <b>Professional Certifications:</b>
        <Form.List name="professionalcertifications">
          {(fields, { add, remove }) => (
            <>
              {fields.map(({ key, name, ...restField }) => (
                <StyleRow gutter={16} className="mt-2">
                  <Col xs={24} sm={24} md={24}>
                    <Form.Item
                      {...restField}
                      label="Certification Type"
                      name={[name, "certificationtype"]}
                      // rules={[
                      //   {
                      //     required: true,
                      //     message: "Certification Type required",
                      //   },
                      // ]}
                    >
                      <Select
                        showSearch
                        placeholder="Select"
                        optionFilterProp="children"
                        getPopupContainer={() => containerRef.current}
                        defaultValue={AwardList[0]}
                        // onChange={onFinish}
                      >
                        {AwardList?.map((value, index) => (
                          <Select.Option
                            key={index}
                            value={value}
                            label={value}
                          >
                            {value}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={12} ref={containerRef}>
                    <Form.Item
                      {...restField}
                      label="From:"
                      name={[name, "fromdate"]}
                      // rules={[
                      //   { required: true, message: "Date required" },
                      // ]}
                    >
                      <DatePicker
                        className="w-100"
                        format="DD-MM-YYYY"
                        // onChange={() => {
                        //   onFinish();
                        // }}
                        placeholder="From"
                        getPopupContainer={() => containerRef.current}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={12} ref={containerRef}>
                    <Form.Item
                      {...restField}
                      label="To:"
                      name={[name, "todate"]}
                      // rules={[
                      //   { required: true, message: "Date required" },
                      // ]}
                    >
                      <DatePicker
                        className="w-100"
                        format="DD-MM-YYYY"
                        // onChange={() => {
                        //   onFinish();
                        // }}
                        placeholder="To"
                        getPopupContainer={() => containerRef.current}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={24}>
                    <Form.Item
                      {...restField}
                      label="Remarks"
                      name={[name, "remarks"]}
                      // rules={[
                      //   { required: true, message: "Remarks required" },
                      // ]}
                    >
                      <Input
                        placeholder="Remarks"
                        // onChange={() => {
                        //   onFinish();
                        // }}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={24}>
                    <Form.Item
                      {...restField}
                      label="Attachment"
                      name={[name, "attachment"]}
                      valuePropName="fileList"
                      getValueFromEvent={(e) => {
                        if (Array.isArray(e)) {
                          return e;
                        }
                        return e && e.fileList;
                      }}
                    >
                      <Upload
                        beforeUpload={beforeUpload}
                        customRequest={({ file, onSuccess }) => {
                          const reader = new FileReader();
                          reader.readAsDataURL(file);

                          reader.onload = () => {
                            const base64Data = reader.result.split(",")[1];
                            const uniqueId = generateUniqueId();
                            onSuccess({ file, base64Data, uniqueId });
                          };

                          reader.onerror = (error) => {
                            console.error("File read error:", error);
                          };
                        }}
                        name="logo"
                        // action="/upload.do"
                        onChange={(value) => {
                          //  onFinish();
                          uploadFile(value);
                        }}
                        // onRemove={(file) => {
                        //   handleFileRemove(file);
                        // }}
                        listType="picture"
                        style={{ width: "100%" }}
                      >
                        <div style={{ width: "100%" }}>
                          <Button className="w-100 text-start" size="large">
                            Upload File
                          </Button>
                        </div>
                      </Upload>
                    </Form.Item>
                  </Col>
                </StyleRow>
              ))}
              <Form.Item>
                <u
                  className="bg-transparent border-0 text-start"
                  type="dashed"
                  onClick={() => add()}
                  block
                >
                  +Add Another
                </u>
              </Form.Item>
            </>
          )}
        </Form.List>
        <div className="text-end">
          <StyledButton type="primary" onClick={goBack}>
            Back
          </StyledButton>
          <StyledButton type="primary" htmlType="submit">
            Next
          </StyledButton>
        </div>
      </Form>
    </div>
  );
}

export default EducationInfo;
